import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { LabApiKey } from "@/services/backend/samples/types/laboratory";
import t from "@/lang/lang";
import { NullUUID } from "@/shared/lib/utilities/uuid";

export function LabApiKeySelect({
  value,
  onValueChange,
  disabled,
}: {
  value: LabApiKey;
  onValueChange: (value: LabApiKey) => void;
  disabled?: boolean;
}) {
  // workaround to handle zero value / empty string with select item
  const val = value !== "" ? value : NullUUID;

  const onValChange = (newVal: string) => {
    onValueChange(newVal === NullUUID ? LabApiKey.Zero : (newVal as LabApiKey));
  };

  return (
    <Select value={val} onValueChange={onValChange} disabled={disabled}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t("Keine")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectItem value={NullUUID}>Keine API</SelectItem>
          <SelectItem value={LabApiKey.Aysid}>AYSID</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
